
const pl_pseudoCharMap = {
  'a': 'ą', // \u0105
  'c': 'ć', // \u0107
  'd': 'đ', // \u0111
  'e': 'ę', // \u0119
  'i': 'í', // \u00ed
  'l': 'ł', // \u0142
  'n': 'ň', // \u0148
  'o': 'ő', // \u0151
  'r': 'ř', // \u0159
  's': 'ś', // \u015B
  't': 'ţ', // \u0163
  'u': 'ű', // \u0171
  'z': 'ż', // \u017C
  'A': 'Ą', // \U0104
  'C': 'Ć', // \U0106
  'D': 'Đ', // \U0110
  'E': 'Ę', // \U0118
  'I': 'Í', // \U00CD
  'L': 'Ł', // \U0141
  'N': 'Ň', // \U0147
  'O': 'Ő', // \U0150
  'R': 'Ř', // \U0158
  'S': 'Ś', // \U015A
  'T': 'Ţ', // \U0162
  'U': 'Ű', // \U0170
  'Z': 'Ż'  // \U017B
};

/**
 * @type {Map} Mapping table for pseudo-French
 * @ignore
 */
const fr_pseudoCharMap = {
  'a': 'å', // \u00E5
  'b': 'þ', // \u00FE
  'c': 'ç', // \u00E7
  'd': 'ð', // \u00F0
  'e': 'ë', // \u00EB
  'i': 'î', // \u00EE
  'n': 'ñ', // \u00F1
  'o': 'ǿ', // \u00F8
  'u': 'ü', // \u00FC
  'y': 'ÿ', // \u00FD
  'A': 'Å', // \U00C5
  'B': 'ß', // \U00DF
  'C': 'Ç', // \U00C7
  'D': 'Ð', // \U00D0
  'E': 'Ë', // \U00CB
  'I': 'Î', // \U00CE
  'N': 'Ñ', // \U00D1
  'O': 'Ǿ', // \U00D8
  'U': 'Ü', // \U00DC
  'Y': 'Ÿ'  // \U00DD
};

const ar_pseudoCharMap = {
  'A': 'ٯ', // \u066F
  'B': 'إ', // \u0625
  'C': 'ژ', // \u0698
  'D': 'ٺ', // \u067A
  'E': 'ٻ', // \u067B
  'F': 'ټ', // \u067C
  'G': 'ں', // \u06BA
  'H': 'آ', // \u0622   
  'I': 'ک', // u06A9
  'J': 'ھ', // u06BE
  'K': 'ٹ', // u0679
  'L': 'ہ', // u06C1
  'M': 'ٽ', // u067D
  'N': 'أ', // u0623
  'O': 'گ', // u06AF
  'P': 'ے', // u06D2
  'Q': 'ٿ', // u067F
  'R': 'ج', // u062C
  'S': 'ڀ', // u0680
  'T': 'ځ', // u0681
  'U': 'پ', // u067E
  'V': 'ؤ', // u0624
  'W': 'ڂ', // u0682
  'X': 'ي', // u064A
  'Y': 'چ', // u0686    
  'Z': 'ة', // u0629
  'a': 'ش', // u0634
  'b': 'ذ', // u0630
  'c': 'ز', // u0632
  'd': 'ڈ', // u0688
  'e': 'ث', // u062B
  'f': 'ب', // u0628
  'g': 'ل', // u0644
  'h': 'ا', // u0627   
  'i': 'ه', // u0647
  'j': 'ت', // u062A
  'k': 'ن', // u0646    
  'l': 'م', // u0645
  'm': 'ئ', // u0626    
  'n': 'د', // u062F
  'o': 'خ', // u062E
  'p': 'ح', // u062D
  'q': 'ض', // u0636    
  'r': 'ق', // u0642
  's': 'س', // u0633
  't': 'ف', // u0641
  'u': 'ع', // u0639
  'v': 'ر', // u0631
  'w': 'ص', // u0635
  'x': 'ط', // u0637
  'y': 'غ', // u063A        
  'z': 'ظ' // u0638
};

module.exports = {
    pl_pseudoCharMap,
    fr_pseudoCharMap,
    ar_pseudoCharMap
}